import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

// https://github.com/vuetifyjs/vue-cli-plugin-vuetify/issues/43#issuecomment-435088739

Vue.use(Vuetify, {
  iconfont: "md"
});
